import { Vector3ConstantPropertyReference } from './babylon/material/PropertyWrappers.js';
export class MaterialHandle {
    constructor(id, viewer) {
        this.id = id;
        this.viewer = viewer;
    }
    get roughness() {
        return this.viewer.get_roughness(this.id);
    }
    set roughness(r) {
        this.viewer.set_roughness(this.id, r);
    }
    get metallic() {
        return this.viewer.get_metallic(this.id);
    }
    set metallic(m) {
        this.viewer.set_metallic(this.id, m);
    }
    get base_color() {
        return this.viewer.get_base_color(this.id);
    }
    set base_color(c) {
        this.viewer.set_base_color(this.id, c);
    }
    get base_color_texture() {
        return this.viewer.get_base_color_texture(this.id);
    }
    set base_color_texture(tex) {
        this.viewer.set_base_color_texture(this.id, tex);
    }
    get unlit() {
        return this.viewer.get_unlit(this.id);
    }
    set unlit(unlit) {
        this.viewer.set_unlit(this.id, unlit);
    }
    get light_map_texture() {
        return this.viewer.get_lightmap_texture(this.id);
    }
    set light_map_texture(tex) {
        this.viewer.set_lightmap_texture(this.id, tex);
    }
}
export class ObjectHandle {
    constructor(id, viewer) {
        this.id = id;
        this.viewer = viewer;
        const v = viewer;
        const object = v.viewer_scene.objects.get(id);
        this._position = new Vector3ConstantPropertyReference(object, 'position');
        this._rotation = new Vector3ConstantPropertyReference(object, 'rotation');
        this._scale = new Vector3ConstantPropertyReference(object, 'scale');
    }
    get position() {
        return this._position;
    }
    set position(v) {
        this.viewer.set_position(this.id, v.x, v.y, v.z);
    }
    get rotation() {
        return this._rotation;
    }
    set rotation(v) {
        this.viewer.set_rotation(this.id, v.x, v.y, v.z);
    }
    get scale() {
        return this._scale;
    }
    set scale(v) {
        this.viewer.set_scale(this.id, v.x, v.y, v.z);
    }
    get material() {
        return this.viewer.get_material(this.id);
    }
    set material(mid) {
        this.viewer.set_material(this.id, mid);
    }
    get outline() {
        return this.viewer.get_outline(this.id);
    }
    set outline(enable) {
        this.viewer.set_outline(this.id, enable, false);
    }
    get outline_block() {
        return this.viewer.get_outline_block(this.id);
    }
    set outline_block(enable) {
        this.viewer.set_outline_block(this.id, enable, false);
    }
    get visible() {
        return this.viewer.get_visible(this.id);
    }
    set visible(v) {
        this.viewer.set_visible(this.id, v, false);
    }
    get enabled() {
        return this.viewer.get_enabled(this.id);
    }
    set enabled(v) {
        this.viewer.set_enabled(this.id, v);
    }
    get enable_on_click() {
        return this.viewer.get_enable_on_click(this.id);
    }
    set enable_on_click(enable) {
        this.viewer.set_enable_on_click(this.id, enable, false);
    }
    get enble_on_drag() {
        return this.viewer.get_enable_on_drag(this.id);
    }
    set enble_on_drag(enable) {
        this.viewer.set_enable_on_drag(this.id, enable, false);
    }
    set cast_shadow(v) {
        this.viewer.set_cast_shadow(this.id, v, false);
    }
    get cast_shadow() {
        return this.viewer.get_cast_shadow(this.id);
    }
    set receive_shadow(v) {
        this.viewer.set_receive_shadow(this.id, v, false);
    }
    get receive_shadow() {
        return this.viewer.get_receive_shadow(this.id);
    }
    // Only allow add child, skip implementing unparented_child
    // because its unclear what should happen to its parent.
    // Children can be unparented by setting their parent to either null or other parent
    add_child(child) {
        this.viewer.set_parent(child, this.id);
    }
    set parent(parent) {
        this.viewer.set_parent(this.id, parent);
    }
    get parent() {
        return this.viewer.get_parent(this.id);
    }
    get children() {
        return this.viewer.get_children(this.id);
    }
    get on_pointer_enter_observable() {
        return this.viewer.get_object_pointer_enter_observable(this.id);
    }
    get on_pointer_leave_observable() {
        return this.viewer.get_object_pointer_leave_observable(this.id);
    }
}
//# sourceMappingURL=common.js.map